import React from 'react';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import "./theme/_main.scss"
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { DetachedTextBlockEditor } from '@plone/volto-slate/blocks/Text/DetachedTextBlockEditor';
import FadeInSection from "../../customizations/components/theme/Animations/FadeInSection"

const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;

    if (!data) {
        return <div>missing data</div>;
    }

    return (
        <FadeInSection>
            <section className="formular-block">
                <h2 id="formular-heading" className="visually-hidden">
                    Formular Block
                </h2>
                {isEditMode ? (<DetachedTextBlockEditor {...filteredToolbarProps} />) : (<TextBlockView {...props} />)}
                <ConditionalLink to={flattenToAppURL(data.link)} condition={!isEditMode}>
                    <div className='pretty'>
                        <button aria-label={data.textButton}>
                            {data.textButton}
                        </button>
                    </div>
                </ConditionalLink>
            </section>
        </FadeInSection>
    );
};

export default View;